export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/ValuSVG.ef9e9190.svg","height":21,"width":54,"blurWidth":0,"blurHeight":0};